module.exports = __webpack_public_path__ + "img/sdg1_jp.0378e1e0.png";